// react-flatpickr components
import Flatpickr from "react-flatpickr";

// react-flatpickr styles
import "flatpickr/dist/flatpickr.css";

import dbDate from "../Utilities/dbDate";
import { Polish } from "flatpickr/dist/l10n/pl.js"
import {InputAdornment, TextField} from "@mui/material";
import React from "react";
import {CalendarMonth} from "@mui/icons-material";

function DatePicker({ input, ...rest }) {
    if (rest.options !== undefined ) {
        rest.options['locale'] = Polish;
    } else {
        rest['options'] = {locale: Polish};
    }
    return (
        <Flatpickr
            {...rest}
            render={({ defaultValue, value }, ref) => (
                <TextField {...input} fullWidth
                           slotProps={{
                               input: {
                                   endAdornment: <InputAdornment position="end"><CalendarMonth /></InputAdornment>,
                               },
                           }} value={rest.options['mode'] === 'range' ? defaultValue : dbDate(value)} inputRef={ref} />
            )}
        />
    );
}

export default DatePicker;
